import moment from "moment";
import React from "react";

const StatusBadge = ({ date, status }) => {
  const status_date =
    date && date !== "" && date !== null
      ? ` ${moment(date).utc().local().format("DD MMM YYYY HH:mm")}`
      : "";
  return (
    <div>
      {status === "revoked" ? (
        <span className="badge badge-pill bg-danger">Revocada</span>
      ) : status === "cancelled" ? (
        <span className="badge badge-pill bg-danger">
          Cancelada el {status_date}
        </span>
      ) : status === "active" ? (
        <span className="badge badge-pill bg-success">Activa</span>
      ) : status === "completed" ? (
        <span className="badge badge-pill bg-success">Completada</span>
      ) : status === "pending" ? (
        <span className="badge badge-pull bg-warning text-dark">Pendiente</span>
      ) : status === "failed" ? (
        <span className="badge badge-pull bg-danger text-white">Fallido</span>
      ) : status === "paused" ? (
        <span className="badge badge-pull bg-secondary text-capitalize">
          Pausada el {status_date}
        </span>
      ) : (
        <span className="badge badge-pull bg-secondary text-capitalize">
          {status}
          {status_date}
        </span>
      )}
    </div>
  );
};
export default StatusBadge;
